export default "__VITE_ASSET__30f088c7__$_?nuxt_component=async&nuxt_component_name=SvgoFreechain__"